import { render, staticRenderFns } from "./ChatLine.vue?vue&type=template&id=135c5ce4&"
import script from "./ChatLine.vue?vue&type=script&lang=js&"
export * from "./ChatLine.vue?vue&type=script&lang=js&"
import style0 from "./ChatLine.vue?vue&type=style&index=0&id=135c5ce4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports